import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import PaginationTable from "../../components/common/PaginationTable/PaginationTable";
import Listings from "../../components/common/Listings/Listings";
import PageSpinner from '../../components/common/PageSpinner/PageSpinner';
import styles from "./DashboardListings.module.css";
import { apiFetch } from "../../utils/api";

import * as Sentry from "@sentry/react";


const columns = [
    { label: "Name", key: "name", width: "100%" },
    { label: "Category", key: "category", width: "180px" },
    { label: "Price", key: "price", width: "180px" },
    { label: "Likes", key: "likes", width: "160px" },
    { label: "Sales", key: "sales", width: "60px" },
];

const DashboardListings = () => {
    const [ isPageLoading, setIsPageLoading ] = useState(false);
    const [data, setData] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    useEffect(() => {
        const fetchListings = async () => {
            try {
                setIsPageLoading(true);
                const response = await apiFetch("/api/memories/user", {}, true);
                setData(response);
            } catch (error) {
                Sentry.captureException(error);
                console.error("❌ Failed to fetch listings:", error);
            } finally {
                setIsPageLoading(false);
            }
        };
        fetchListings();
    }, []);

    const handlePageChange = (newPage, sortColumn, sortOrder) => {
        console.log(`Fetching page ${newPage} sorted by ${sortColumn} (${sortOrder})`);
    };

    const handleSortChange = (column, order) => {
        console.log(`Sorting by ${column} in ${order || 'none'} order`);
        setSortColumn(order ? column : null);
        setSortOrder(order || "asc");

        if (!order) {
            setData(listingData);
        } else {
            const sortedData = [...data].sort((a, b) => {
                if (a[column] < b[column]) return order === "asc" ? -1 : 1;
                if (a[column] > b[column]) return order === "asc" ? 1 : -1;
                return 0;
            });
            setData(sortedData);
        }
    };


    if (isPageLoading) {
        return <PageSpinner />;
    }

    return (
        <Box className={styles.dashboardListings}>
            <Typography variant="h2" className={styles.heading}>Your Listings</Typography>
            <PaginationTable
                data={data}
                columns={columns}
                component={Listings}
                onPageChange={handlePageChange}
                onSortChange={handleSortChange}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
            />
        </Box>
    );
};

export default DashboardListings;